import React, { useState } from 'react';
import { ButtonBase, ButtonBaseProps, CircularProgress } from '@mui/material';
import ButtonContent from './index.styles';

interface LoadingButtonProps extends Omit<ButtonBaseProps, 'onClick'> {
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => Promise<any> | void;
}

const LoadingButton = ({
  onClick,
  children,
  disabled,
  ...otherProps
}: LoadingButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const onClickInner = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    if (!onClick) return;

    const res = onClick(e);
    if (typeof res?.then === 'function') {
      setIsLoading(true);
      res.finally(() => setIsLoading(false));
    }
  };

  return (
    <ButtonBase
      {...otherProps}
      disabled={disabled || isLoading}
      onClick={onClickInner}
    >
      {isLoading ? (
        <ButtonContent className="LoadingButton-content">
          <CircularProgress size={'1.5em'} sx={{ color: 'inherit' }} />
        </ButtonContent>
      ) : (
        // wrapped this in div to fix google translate error
        <ButtonContent className="LoadingButton-content">
          {children}
        </ButtonContent>
      )}
    </ButtonBase>
  );
};

export default LoadingButton;
